import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';

import { formatAsDistance, formatAsEmission } from 'cpnl-common';

i18n.use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
        fallbackLng: 'nl',
        load: 'languageOnly',
        preload: ['nl'],
        ns: [
            'change-address',
            'contact-details-edit',
            'contact-handover',
            'contracts',
            'dashboard',
            'financial-details',
            'greeting',
            'my-profile',
            'navigation',
            'open-verification',
            'request',
            'total-early-settlement',
            'translation',
            'unpaid-balance',
        ],
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
            format(value, format) {
                if (format === 'distance') {
                    return formatAsDistance(value);
                }
                if (format === 'emission') {
                    return formatAsEmission(value);
                }
                return value;
            },
        },
        backend: {
            loadPath: `/locales/{{lng}}/{{ns}}.json`,
        },
        whitelist: ['nl'],
    });

export default i18n;
